import { useState } from 'src/composables/useState.js'
import { CustomGroupsAPI } from 'src/api/index.js'
import { bus } from 'boot/bus.js'
import { useStore } from 'vuex'

const { isCustomGroupLoading, customGroup, $reset } = useState({
  isCustomGroupLoading: false,
  customGroup: {},
})

export const useCustomGroup = () => {
  const store = useStore()

  const getCustomGroup = async () => {
    bus.$emit('cancelCustomGroupsGet')
    isCustomGroupLoading.value = true
    try {
      customGroup.value = await CustomGroupsAPI.get(
        {},
        { customCancelEvent: 'cancelCustomGroupsGet' }
      )
    } catch (error) {}
    isCustomGroupLoading.value = false
  }

  const getSettingsDealerships = () => {
    const { settings } = store.state
    return settings.dealerShipId
      .split(',')
      .filter((item) => +item !== store.getters.allDealershipId)
  }
  const getCustomGroupsDealerGroupIds = () => {
    const { settings } = store.state
    const dealerships = getSettingsDealerships()
    if (settings.dealerGroupIds !== null) {
      const dealerGroups = settings.dealerGroupIds.split(',')
      const dealerGroupsDealerships = dealerGroups.reduce((acc, dealerGroupId) => {
        const dealerGroup = customGroup.value.dealerGroups.find(({ id }) => id === +dealerGroupId)
        if (dealerGroup === undefined) {
          return acc
        }

        const dealerGroupDealerships = dealerGroup.dealerships.map(({ id }) => id)
        return [...acc, ...dealerGroupDealerships]
      }, [])
      if (dealerGroupsDealerships.length === dealerships.length) {
        return dealerGroups
      }
    }

    return null
  }
  const getCustomGroupsDealerships = () => {
    const dealerships = getSettingsDealerships()
    if (getCustomGroupsDealerGroupIds() === null && dealerships.length > 0) {
      return dealerships
    }
    return null
  }

  return {
    isCustomGroupLoading,
    customGroup,
    getCustomGroup,
    getCustomGroupsDealerships,
    getCustomGroupsDealerGroupIds,
    $resetCustomGroup: $reset,
  }
}
